// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Initial hidden state */
.fade-in-hidden {
  opacity: 0;
  transform: translateY(20px); /* Startet mit leichter Verschiebung */
  transition: opacity 1s ease, transform 1s ease;
}

/* Fade-In sichtbar */
.fade-in {
  opacity: 1;
  transform: translateY(0); /* Zurück zur ursprünglichen Position */
}

/* Bestehendes Styling bleibt unverändert */
.location-wrapper {
  background-color: black;
  padding: 20px 0;
  text-align: center;
}

.location-inner {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  background-color: #a1a1a12a;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 20px;
  align-items: center;
}

.location-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.company-info,
.hours-info {
  margin-bottom: 20px;
}

.company-info h2,
.hours-info h2 {
  font-size: 1.5rem;
  color: #ffffff;
  margin-bottom: 10px;
}

.company-info p,
.hours-info p {
  color: #9b9b9b;
  font-size: 1rem;
  margin: 5px 0;
}

.location-map {
  flex: 1 1;
  height: 450px;
  border-radius: 15px 15px 15px 15px;
  overflow: hidden;
}

.location-map iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .location-inner {
    flex-direction: column;
    padding: 15px;
  }

  .location-info,
  .location-map {
    width: 100%;
  }

  .location-map {
    height: 300px;
  }
}

@media (max-width: 480px) {
  .company-info h2,
  .hours-info h2 {
    font-size: 1.2rem;
  }

  .company-info p,
  .hours-info p {
    font-size: 0.9rem;
  }

  .location-map {
    height: 250px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/components/Location.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,UAAU;EACV,2BAA2B,EAAE,sCAAsC;EACnE,8CAA8C;AAChD;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,wBAAwB,EAAE,uCAAuC;AACnE;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Initial hidden state */\r\n.fade-in-hidden {\r\n  opacity: 0;\r\n  transform: translateY(20px); /* Startet mit leichter Verschiebung */\r\n  transition: opacity 1s ease, transform 1s ease;\r\n}\r\n\r\n/* Fade-In sichtbar */\r\n.fade-in {\r\n  opacity: 1;\r\n  transform: translateY(0); /* Zurück zur ursprünglichen Position */\r\n}\r\n\r\n/* Bestehendes Styling bleibt unverändert */\r\n.location-wrapper {\r\n  background-color: black;\r\n  padding: 20px 0;\r\n  text-align: center;\r\n}\r\n\r\n.location-inner {\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  background-color: #a1a1a12a;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  gap: 20px;\r\n  align-items: center;\r\n}\r\n\r\n.location-info {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.company-info,\r\n.hours-info {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.company-info h2,\r\n.hours-info h2 {\r\n  font-size: 1.5rem;\r\n  color: #ffffff;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.company-info p,\r\n.hours-info p {\r\n  color: #9b9b9b;\r\n  font-size: 1rem;\r\n  margin: 5px 0;\r\n}\r\n\r\n.location-map {\r\n  flex: 1;\r\n  height: 450px;\r\n  border-radius: 15px 15px 15px 15px;\r\n  overflow: hidden;\r\n}\r\n\r\n.location-map iframe {\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none;\r\n}\r\n\r\n/* Responsive Styles */\r\n@media (max-width: 768px) {\r\n  .location-inner {\r\n    flex-direction: column;\r\n    padding: 15px;\r\n  }\r\n\r\n  .location-info,\r\n  .location-map {\r\n    width: 100%;\r\n  }\r\n\r\n  .location-map {\r\n    height: 300px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .company-info h2,\r\n  .hours-info h2 {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .company-info p,\r\n  .hours-info p {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .location-map {\r\n    height: 250px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
